import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, FloatButton, Modal } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ProjectModal } from './components/project-modal'
import { useModal } from '../../../common/hooks/formik/modal.hook'
import { ModalBottom } from '../../../common/ui/modal/modal-bottom'
import { PureTable } from '../../../common/ui/pure-table/pure-table'
import { useProjectStore } from '../../../entities/projects/stores/project.store'
import { CreateProjectDto, Project } from '../../../entities/projects/types/project.types'
import { useUserStore } from '../../../entities/user/stores/user.store'

export const ProjectsPage = () => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null)

  const projectsStore = useProjectStore()
  const user = useUserStore((state) => state.user)
  const { t } = useTranslation()
  const projectModal = useModal(false)
  const projectModalFormRef = useRef<{ submit: () => void } | null>(null)

  useEffect(() => {
    projectsStore.loadProjects()
  }, [projectsStore.loadProjects])

  const handleSaveProject = (props: CreateProjectDto) => {
    const createProjectProps = {
      ...props,
      organizationId: user?.organization?.id ?? 0,
    }
    projectsStore.saveProject(createProjectProps)
    projectModal.close()
  }

  const handleDeleteProject = (id: number) => {
    alert('id!')
  }

  const columns = [
    {
      title: t('settings.projects.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: Project) => (
        <span
          onClick={() => {
            setSelectedProject(record)
            projectModal.open()
          }}
          style={{ cursor: 'pointer', color: '#1890ff' }}
        >
          {text}
        </span>
      ),
    },
    {
      title: t(''),
      key: 'actions',
      width: '10px',
      render: (_: unknown, record: { id: number; name: string }) => (
        <Button
          color="danger"
          onClick={() => {
            Modal.confirm({
              title: t('settings.projects.deleteConfirmTitle'),
              content: `${record.name} ${t('settings.projects.deleteDescription')}`,
              onOk: () => handleDeleteProject(record.id),
            })
          }}
          variant="text"
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ]

  return (
    <>
      <div>
        <PureTable
          columns={columns}
          dataSource={projectsStore.projects}
          rowKey="id"
        />
        <FloatButton
          icon={<PlusOutlined />}
          onClick={() => {
            setSelectedProject(null)
            projectModal.open()
          }}
          type="primary"
        />
      </div>
      <ModalBottom
        cancelText={t('common.cancel')}
        okText={t('common.save')}
        onCancel={projectModal.close}
        onOk={() => projectModalFormRef.current?.submit()}
        open={projectModal.opened}
        title={selectedProject?.name ?? t('settings.projects.addNewHeader')}
      >
        <ProjectModal
          key={selectedProject?.id ?? 'new'}
          ref={projectModalFormRef}
          initialValues={selectedProject}
          onSubmit={handleSaveProject}
        />
      </ModalBottom>
    </>
  )
}
